/** Tracks fresh sign-up / incomplete setup so onboarding always runs after register. */
const PENDING_KEY = "kipabiz_pending_onboarding";
const WELCOME_KEY = "kipabiz_welcome_seen";

export function markPendingOnboarding() {
  sessionStorage.setItem(PENDING_KEY, "1");
}

export function clearPendingOnboarding() {
  sessionStorage.removeItem(PENDING_KEY);
}

export function hasPendingOnboarding() {
  return sessionStorage.getItem(PENDING_KEY) === "1";
}

export function hasSeenWelcome() {
  return localStorage.getItem(WELCOME_KEY) === "1";
}

export function markWelcomeSeen() {
  localStorage.setItem(WELCOME_KEY, "1");
}
